import { io } from "socket.io-client";

// Create a mock socket for development when CORS blocks the connection
const createMockSocket = () => {
  const mockSocket = {
    connected: false,
    id: 'mock-socket-id',
    on: (event, callback) => {
      if (event === 'connect') {
        // Simulate connection after a delay
        setTimeout(() => {
          mockSocket.connected = true;
          console.log("Mock socket: Connected with ID:", mockSocket.id);
          callback();
        }, 1000);
      } else if (event === 'clients') {
        // Simulate client count updates
        setInterval(() => {
          const mockCount = Math.floor(Math.random() * 50) + 10; // Random count between 10-60
          console.log("Mock socket: Sending mock clients data:", { clients: mockCount });
          callback({ clients: mockCount });
        }, 5000);
      }
    },
    off: () => {},
    emit: () => {},
    disconnect: () => {
      mockSocket.connected = false;
    }
  };
  return mockSocket;
};

// Try to connect to the real WebSocket server
let socket;
try {
  socket = io.connect("wss://glorybe.app", {
    transports: ['websocket'],
    upgrade: false,
    withCredentials: false,
    forceNew: true
  });

  // Add debugging
  console.log("Socket service: Creating socket connection to wss://glorybe.app");
  console.log("Socket service: Socket object:", socket);

  // Log connection events
  socket.on("connect", () => {
    console.log("Socket service: Connected with ID:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("Socket service: Disconnected");
  });

  socket.on("connect_error", (error) => {
    console.log("Socket service: Connection error:", error);
    console.log("Socket service: Falling back to mock socket for development");
  });

} catch (error) {
  console.log("Socket service: Failed to create socket, using mock:", error);
  socket = createMockSocket();
}

export default socket;
